var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.aparelhos,"label":"Aparelho","item-text":"text","item-value":"value"},model:{value:(_vm.aparelhoSelecionado),callback:function ($$v) {_vm.aparelhoSelecionado=$$v},expression:"aparelhoSelecionado"}})}
var staticRenderFns = []

export { render, staticRenderFns }